import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Audit Checks\"}}\n\n<NwSiteAuditChecksPage\n  @model={{this.model}}\n  @checkPath=\"dashboard.url.site-audit.all.checks.show\"\n/>")